export default __webpack_public_path__ + "static/media/sheep-orange.b6af135c.jpeg";